// src/components/SalidaEntradaPatrones/Dashboard.jsx
import React, { useState, useEffect } from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  InputGroup,
  Form,
  Button,
  Spinner,
  Alert,
  Badge,
  Table
} from 'react-bootstrap';
import {
  FaBox,
  FaCheckCircle,
  FaTimesCircle,
  FaSearch,
  FaSyncAlt,
  FaChartLine,
  FaClock
} from 'react-icons/fa';
import { getPatronesStats, getAllPatrones, searchPatrones, getPatronStatus } from '../../api/patronesService';
import { getMovimientosStats, getMovimientosActivos } from '../../api/movimientosService';
import StatusBadge from './StatusBadge';
import moment from 'moment';
import 'moment/locale/es';
import { getMovimientoAbiertoCount, postPatronesBasico } from '../../api/common';

moment.locale('es');

/**
 * Vista Dashboard principal de movimientos de patrones
 */
const Dashboard = ({ onViewMovimiento, onViewPatronHistorial }) => {
  const [stats, setStats] = useState({
    totalDisponibles: 0,
    totalEnServicio: 0,
    movimientosActivos: 0,
    movimientosCerradosHoy: 0
  });
  const [patronesEnServicio, setPatronesEnServicio] = useState([]);
  console.log('Patrones en servicio:', stats);
  const [searchText, setSearchText] = useState('');
  const [searchResult, setSearchResult] = useState(null);
  const [loading, setLoading] = useState(false); // Cambiado a false inicialmente
  const [searching, setSearching] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [dataCargada, setDataCargada] = useState(false); // Flag para saber si ya cargamos datos




  useEffect(() => {
    // Solo cargar datos si no hemos cargado antes
    if (!dataCargada) {
      cargarDatos();
    }
    // necesito filtrar  patronesEnServicio y sacar los unitariod de xonsecutivo para saber cuantos movimientosActivos son
  }, []); // Sin dependencias - solo se ejecuta al montar

  // Efecto separado para el refresh manual
  useEffect(() => {
    if (refreshKey > 0) {
      cargarDatos();
    }
  }, [refreshKey]);

  const cargarDatos = async () => {
    setLoading(true);
    try {

        // Cargar todos los patrones 
      // Cargar estadísticas en paralelo
      const [patronesStatsRes, patronesEnServicioRes] = await Promise.all([
        getPatronesStats(),
        postPatronesBasico({ inService: true })
      ]);

      const movimientosOpenRes = await getMovimientosActivos();  // carga los movimeintos activos uno por cada patron
      const MovimientosAbiertoCount= await getMovimientoAbiertoCount()  //Solo carga las cantidades 
      
      setStats(prevStats => ({
        ...prevStats,
        totalDisponibles: patronesStatsRes.data.totalDisponibles,
        totalEnServicio: patronesStatsRes.data.totalEnServicio,
        movimientosActivos: MovimientosAbiertoCount.data.count || 0,
        movimientosCerradosHoy: 0
    }));

      // Cargar información completa de patrones en servicio con sus movimientos

      console.log('patronesEnServicioRes', patronesEnServicioRes);
      const patronesConMovimientos = await Promise.all(
        (patronesEnServicioRes.data.data || []).map(async (patron) => {
          try {
            const statusRes = await getPatronStatus(patron._id);  //que hace esto ?
            return {
              ...patron,
              movimiento: statusRes.data.currentMovement,
              responsable: statusRes.data.currentResponsible,
              ots: statusRes.data.currentOts
            };
          } catch (error) {
            console.error(`Error al cargar status del patrón ${patron._id}:`, error);
            return patron;
          }
        })
      );

      console.log('patronesConMovimientos', patronesConMovimientos);
      setPatronesEnServicio(movimientosOpenRes.data || []);
      setDataCargada(true); // Marcar que ya cargamos datos
    } catch (error) {
      console.error('Error al cargar datos del dashboard:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = async () => {
    if (!searchText.trim()) {
      setSearchResult(null);
      return;
    }

    setSearching(true);
    try {
      const response = await searchPatrones(searchText);
      
      if (response.data && response.data.length > 0) {
        const patron = response.data[0];
        const statusRes = await getPatronStatus(patron._id);
        setSearchResult(statusRes.data);
      } else {
        setSearchResult({ notFound: true });
      }
    } catch (error) {
      console.error('Error al buscar patrón:', error);
      setSearchResult({ error: true });
    } finally {
      setSearching(false);
    }
  };

  const handleRefresh = () => {
    setRefreshKey(prev => prev + 1);
  };

  const getTiempoFuera = (startedAt) => {
    if (!startedAt) return 'N/A';
    const now = moment();
    const start = moment(startedAt);
    const duration = moment.duration(now.diff(start));

    const days = Math.floor(duration.asDays());
    const hours = duration.hours();

    if (days > 0) {
      return `${days}d ${hours}h`;
    } else if (hours > 0) {
      return `${hours}h`;
    } else {
      return `${duration.minutes()}m`;
    }
  };

  // Mostrar loading solo si no tenemos datos cargados aún
  if (loading && !dataCargada) {
    return (
      <Container fluid className="py-4 text-center">
        <Spinner animation="border" variant="primary" />
        <p className="mt-3">Cargando dashboard...</p>
      </Container>
    );
  }

  return (
    <Container fluid className="py-4">
      {/* Header */}
      <Row className="mb-4">
        <Col>
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h2 className="text-primary fw-bold mb-1">
                <FaChartLine className="me-2" />
                Dashboard - Movimientos de Patrones
              </h2>
              <p className="text-muted mb-0">
                Control de ingreso y salida de equipos patrón
              </p>
            </div>
            <Button
              variant="outline-primary"
              onClick={handleRefresh}
              disabled={loading}
            >
              <FaSyncAlt className={loading ? 'fa-spin' : ''} /> Refrescar
            </Button>
          </div>
        </Col>
      </Row>

      {/* Tarjetas de estadísticas */}
      <Row className="mb-4">
        <Col md={3}>
          <Card className="shadow-sm h-100 border-success border-start border-4">
            <Card.Body className="text-center">
              <FaCheckCircle size={40} className="text-success mb-2" />
              <h6 className="text-muted mb-2">Patrones Disponibles</h6>
              <h2 className="fw-bold text-success mb-0">
                {stats.totalDisponibles}
              </h2>
            </Card.Body>
          </Card>
        </Col>

        <Col md={3}>
          <Card className="shadow-sm h-100 border-danger border-start border-4">
            <Card.Body className="text-center">
              <FaTimesCircle size={40} className="text-danger mb-2" />
              <h6 className="text-muted mb-2">Patrones En Servicio</h6>
              <h2 className="fw-bold text-danger mb-0">
                {stats.totalEnServicio}
              </h2>
            </Card.Body>
          </Card>
        </Col>

        <Col md={3}>
          <Card className="shadow-sm h-100 border-primary border-start border-4">
            <Card.Body className="text-center">
              <FaClock size={40} className="text-primary mb-2" />
              <h6 className="text-muted mb-2">Movimientos Activos</h6>
              <h2 className="fw-bold text-primary mb-0">
                {stats.movimientosActivos}
              </h2>
            </Card.Body>
          </Card>
        </Col>

        <Col md={3}>
          <Card className="shadow-sm h-100 border-info border-start border-4">
            <Card.Body className="text-center">
              <FaBox size={40} className="text-info mb-2" />
              <h6 className="text-muted mb-2">Cerrados Hoy</h6>
              <h2 className="fw-bold text-info mb-0">
                {stats.movimientosCerradosHoy}
              </h2>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Buscador rápido */}
      <Row className="mb-4">
        <Col md={12} className="mx-auto">
          <Card className="shadow-sm w-100">
            <Card.Body className='w-100'>
              <h5 className="mb-3">
                <FaSearch className="me-2" />
                Búsqueda Rápida de Patrón
              </h5>
              <InputGroup>
                <InputGroup.Text>
                  <FaSearch />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  placeholder="Buscar por inventario, item, marca o modelo..."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                />
                <Button
                  variant="primary"
                  onClick={handleSearch}
                  disabled={searching || !searchText.trim()}
                >
                  {searching ? <Spinner animation="border" size="sm" /> : 'Buscar'}
                </Button>
              </InputGroup>

              {/* Resultado de búsqueda */}
              {searchResult && !searchResult.notFound && !searchResult.error && (
                <Card className="mt-3 bg-light w-100">
                  <Card.Body className='w-100'>
                    <div className="d-flex justify-content-end mb-2">
                      <Button
                        variant="link"
                        size="sm"
                        className="text-danger p-0"
                        onClick={() => setSearchResult(null)}
                        title="Cerrar"
                      >
                        <FaTimesCircle size={20} />
                      </Button>
                    </div>
                    <Row>
                      <Col md={6}>
                        <h6 className="fw-bold">{searchResult.patron?.inventario}</h6>
                        <p className="mb-1">{searchResult.patron?.item}</p>
                        <small className="text-muted">
                          {searchResult.patron?.marca} {searchResult.patron?.modelo}
                        </small>
                      </Col>
                      <Col md={6} className="text-end">
                        <StatusBadge
                          type="patron"
                          status={searchResult.inService ? 'en-servicio' : 'disponible'}
                        />
                        {searchResult.inService && searchResult.currentMovement && (
                          <div className="mt-2">
                            <small className="text-muted">
                              Responsable: {searchResult.currentResponsible?.nombre}{' '}
                              {searchResult.currentResponsible?.apellido}
                            </small>
                            <br />
                            <small className="text-muted">
                              Movimiento: {searchResult.currentMovement.groupConsecutive}
                            </small>
                            <br />
                            <Button
                              variant="link"
                              size="sm"
                              onClick={() => onViewMovimiento?.(searchResult.currentMovement)}
                            >
                              Ver detalles
                            </Button>
                          </div>
                        )}
                        {!searchResult.inService && (
                          <div className="mt-2">
                            <Button
                              variant="link"
                              size="sm"
                              onClick={() => onViewPatronHistorial?.(searchResult.patron)}
                            >
                              Ver historial
                            </Button>
                          </div>
                        )}
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              )}

              {searchResult?.notFound && (
                <Alert variant="info" className="mt-3 mb-0">
                  No se encontró ningún patrón con ese criterio de búsqueda
                </Alert>
              )}

              {searchResult?.error && (
                <Alert variant="danger" className="mt-3 mb-0">
                  Error al buscar el patrón. Intenta nuevamente.
                </Alert>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Lista de patrones en servicio */}
      <Row>
        <Col>
          <Card className="shadow-sm w-100">
            <Card.Header className="bg-danger text-white w-100">
              <h5 className="mb-0">
                <FaBox className="me-2" />
                Patrones en Servicio ({patronesEnServicio.length})
              </h5>
            </Card.Header>
            <Card.Body className="w-100">
              {patronesEnServicio.length === 0 ? (
                <Alert variant="success" className="text-center mb-0">
                  <FaCheckCircle size={50} className="mb-3" />
                  <h5>Todos los patrones están disponibles</h5>
                  <p className="mb-0">No hay equipos en servicio en este momento</p>
                </Alert>
              ) : (
                <Table responsive hover>
                  <thead className="table-light">
                    <tr>
                      <th>Inventario</th>
                      <th>Item</th>
                      <th>Marca/Modelo</th>
                      <th>Responsable</th>
                      <th>Movimiento</th>
                      <th className="text-center">OTs</th>
                      <th className="text-center">Tiempo</th>
                      <th className="text-center">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {patronesEnServicio.map((movimiento) => (
                      <tr key={movimiento.patronId._id}>
                        <td>
                          <strong>{movimiento?.patronId?.inventario}</strong>
                        </td>
                        <td style={{ maxWidth: '200px' }}>
                          <div className="text-truncate">{movimiento?.patronId?.item}</div>
                        </td>
                        <td>
                          <small>
                            {movimiento?.patronId?.marca} {movimiento?.patronId?.modelo}
                          </small>
                        </td>
                        <td>
                          <small>
                            {movimiento?.responsibleUserId?.nombre} {movimiento?.responsibleUserId?.apellido}
                          </small>
                        </td>
                        <td>
                          <small className="text-muted">
                            {movimiento.groupConsecutive || 'N/A'}
                          </small>
                        </td>
                        <td className="text-center">
                          <Badge bg="info">
                            {movimiento?.otAssignments?.length || 0}
                          </Badge>
                        </td>
                        <td className="text-center">
                          <small className="text-muted">
                            {getTiempoFuera(movimiento.startedAt)}
                          </small>
                        </td>
                        <td className="text-center">
                          <Button
                            variant="link"
                            size="sm"
                            onClick={() => onViewMovimiento?.(movimiento)}
                          >
                            Ver detalles
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Dashboard;
